document.addEventListener('DOMContentLoaded', () => {
    const checkboxes = document.querySelectorAll('[data-agree-checkbox]');
    const submitButtons = Array.from(document.querySelectorAll('[data-agree-submit]'));

    function onChange(checkbox) {
        const submitBtn = submitButtons.find(button =>
            button.dataset.agreeSubmit === checkbox.dataset.agreeCheckbox);

        if (submitBtn)
            submitBtn.disabled = !checkbox.checked;
    }

    checkboxes.forEach((checkbox) => {
        onChange(checkbox);
        checkbox.addEventListener('change', () => onChange(checkbox));
    });
});